var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticStyle:{"padding":"20px 0 0 30px","width":"100%","height":"100%"}},[_c('h3',{staticStyle:{"height":"30px"}},[_vm._v("店铺数据")]),_c('div',{staticStyle:{"width":"calc(100% - 30px)","height":"calc(100% - 50px)"},attrs:{"id":"div"}})])])
}]

export { render, staticRenderFns }